module.exports = "https://static.energy5.com/_next/static/images/brand2-313f1a340c640878629bcd8c7b2ee6fb.png";